import { EntityLink } from '../../../Entity'
import { FloatingTooltip } from '../../../Floating'
import { TableCellBase } from '../TableCellBase'
import { TableEmptyCell } from '../TableEmptyCell'

import * as styles from './TableLinkCell.module.css'

function TableLinkCell({ disabled, text, tooltip, value, ...cellProps }) {
  return value ? (
    <TableCellBase {...cellProps}>
      <FloatingTooltip content={tooltip}>
        <div className={styles.container}>
          <EntityLink disabled={disabled} text={text} to={value} />
        </div>
      </FloatingTooltip>
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} />
  )
}

export default TableLinkCell
